import styled from "styled-components";

import { theme } from "../../themes/themes";
export const SideMenuButton = styled.div`
  width: 208px;
  height: 240px; /* Adjusted height to accommodate the larger image */
  flex-shrink: 0;
  border-bottom: 4px solid var(--background-background-01, ${({ theme }) => theme.neutral.white});
  background: #fff1f8;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 0.5em;
  padding-inline: 0.5em;
  .heading {
    text-align: center;
    width: 100%;
    color: ${({ theme }) => theme.neutral.black};
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-bottom: 0.5em;
  }
  .btn-img-container {
    width: 120px; /* Adjusted width to accommodate the larger image */
    height: 120px; /* Adjusted height to accommodate the larger image */
    flex-shrink: 0;
    filter: drop-shadow(0px 0px 15px rgba(0, 0, 0, 0.3));
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    &:hover {
      cursor: pointer;
      transform: scale(0.98);
    }
  }
  .img {
    width: 100%;
    height: 100%;
    object-fit: cover; /* To maintain aspect ratio and cover the container */
  }
  .button {
    display: flex;
    width: 58.627px;
    height: 10.824px;
    flex-direction: column;
    justify-content: center;
    flex-shrink: 0;
    color: ${({ theme }) => theme.neutral.white};
    text-align: center;
    font-size: 25px;
    font-style: normal;
    font-weight: 700;
    line-height: 12px;
    position: absolute;
  }
  .clickText {
    margin-top: 10px; // Adjust as per your requirement
    color: ${({ theme }) => theme.primary.purple};
    font-size: 14px;
    font-weight: 700;
    line-height: normal;
    text-align: center;
  }

  .emergencyText {
    margin-top: 5px; // Adjust as per your requirement
    color: ${({ theme }) => theme.primary.purple};
    font-size: 14px;
    font-weight: 500;
    line-height: normal;
    text-align: center;
  }
`;

export const SideMenuButton1 = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: auto;
  height: 178px;
  flex-shrink: 0;
  border-bottom: 4px solid ${({ theme }) => theme.neutral.white};
  background: #ffe5f2;
  .sc-bTllmR {
    margin-right: 14px;
  }
  .label1 {
    width: 65px;
    height: 16px;
    flex-shrink: 0;
    color: ${({ theme }) => theme.primary.purple};
    text-align: center;
    font-feature-settings: "clig" off, "liga" off;

    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  .label2 {
    width: 57px;
    height: 24px;
    flex-shrink: 0;
    color: ${({ theme }) => theme.primary.purple};
    text-align: center;
    font-feature-settings: "clig" off, "liga" off;
    font-family: "Noto Sans", Helvetica;
    font-size: 8px;
    font-style: normal;
    font-weight: 400;
    line-height: 8px; /* 100% */
  }
`;

export const ICEButton = styled.button`
  width: 3.5vw;
  height: 3.5vw;
  border-radius: 50%;
  max-width: 55px;
  max-height: 55px;
  background: radial-gradient(
    53.21% 53.21% at 50% 50%,
    ${({ theme }) => theme.primary.purple} 54.17%,
    ${({ theme }) => theme.primary.purple} 100%
  );
  opacity: ${({ buttonStatus }) => (buttonStatus !== "Open" ? "1" : "0.4")};
  box-shadow: 0px 0px 12px rgb(0 0 0 / 30%);
  outline: none;
  border: none;
  color: ${({ theme }) => theme.neutral.white};
  font-weight: 900;
  font-size: 12px;
  transition: 0.2s all;
  &:hover {
    cursor: pointer;
    transform: scale(0.98);
    box-shadow: 3px 2px 22px 1px rgb(0 0 0 / 24%);
  }
  .push-here {
    font-size: 6px;
    font-weight: 900;
    width: 100%;
    margin: 0;
    @media only screen and (max-width: 750px) {
      font-size: 10px;
    }
  }
  @media only screen and (max-width: 820px) {
    display: none;
  }
`;

export const Label1 = styled.span`
  margin-top: 0.5em;
  margin-bottom: 10px;
  width: 65px;
  height: 16px;
  flex-shrink: 0;
  color: ${({ theme }) => theme.primary.purple};
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const Label2 = styled.span`
  width: 57px;
  height: 24px;
  flex-shrink: 0;
  color: ${({ theme }) => theme.primary.purple};
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.2em;
`;
